import React from "react";
import {useVaultUpdate} from "../util/useVaultUpdate";
import AssetsUtil from "../util/AssetsUtil.js";
import clsx from "clsx";

import * as styles from "./styles/ErrorIcon.css";

type ErrorIconProps = {
	className?: string;
	isWarning?: boolean;
};

// Wrapper component defines the same wrapper appearance for the different icon types.
const IconWrapper = ({
	className,
	children,
}: {
	className?: string;
	children: React.ReactNode;
}) => {
	return <div className={clsx(styles.errorIcon, className)}>{children}</div>;
};

export const ErrorIcon = ({className, isWarning}: ErrorIconProps) => {
	const connected = useVaultUpdate({
		getValuesFromVault: state => state.connected,
	});

	if (connected) {
		return (
			<IconWrapper className={className}>
				<img
					className={styles.errorImg}
					src={AssetsUtil.getOfficeIcon(
						isWarning ? "warning-icon" : "error-icon"
					)}
					alt=""
				/>
			</IconWrapper>
		);
	}

	return (
		<IconWrapper className={className}>
			<div className={styles.errorFallback}>
				<div className={styles.errorFallbackTriangle} />
				<div className={styles.errorFallbackMark}>{"!"}</div>
			</div>
		</IconWrapper>
	);
};
